// Notification de fin de repos, visible même si l'application est en arrière-plan
export function requestNotificationPermission() {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
}

export async function notifyRestDone() {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  const options = { body: 'Repos terminé — à toi de jouer 💪', icon: '/logo192.png', tag: 'rest-done', renotify: true, vibrate: [300, 100, 300] };
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    if (reg) { await reg.showNotification('MuscuApp', options); return; }
    new Notification('MuscuApp', options); // eslint-disable-line no-new
  } catch (_) {}
}
